import { DEFAULT_SBEF_CUSTOM_GROUPS } from '@features/sbef/custom-groups.model';
import {
  createSbefGroupingHelpers,
  ElementGroupingHelpers,
} from './helpers/element-grouping.helpers';
import { SectionRowContentComponent } from '@ui/ElementList/list.model';
import { OneOfListElements } from '@shared/models/project.model';
import { ElementListSbefGroupRowContent } from './components/ElementListSbefGroupRowContent';
import { Results } from '@shared/models/unit.model';
import { IProposal } from '@shared/models/proposals.model';

export const elementGroupingOptions = Object.freeze(['none', 'sbef'] as const);
export type ElementGroupingOption = (typeof elementGroupingOptions)[number];

export type GroupSectionMeta = {
  resultsSum: Results;
  /** Sum of results for this group per proposal */
  proposalResultsSum: Record<IProposal['id'], Results>;
};
type GroupingHelpers = {
  helpers: ElementGroupingHelpers;
  RowContentComponent: SectionRowContentComponent<
    OneOfListElements,
    GroupSectionMeta
  >;
};

const groups = Object.freeze({
  none: undefined,
  sbef: {
    helpers: createSbefGroupingHelpers(DEFAULT_SBEF_CUSTOM_GROUPS),
    RowContentComponent: ElementListSbefGroupRowContent,
  },
} as const satisfies Record<
  ElementGroupingOption,
  GroupingHelpers | undefined
>);

export const getElementGroupingHelpers = (
  groupBy: ElementGroupingOption,
): GroupingHelpers | undefined => groups[groupBy];
